import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

const FaqPostPageLayout = ({ children }) => (
  <div>
    <Header />
    <div className="faq-post-page-container">
      <div className="container">
        {children}
      </div>
    </div>
    <Footer />
  </div>
)

export default FaqPostPageLayout



// WEBPACK FOOTER //
// ./src/layouts/FaqPostPageLayout.js